
const DeviceDetect = (() => {
  const MIN_TABLET_CSS_PX = 600; // 一般的なタブレット最小幅の目安

  const hasTouch = () =>
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);

  const minDim = () => Math.min(window.screen.width, window.screen.height);
  const coarsePointer = () => window.matchMedia?.('(pointer:coarse)').matches ?? false;

  const osFromUA = (ua) => {
    if (/android/i.test(ua)) return 'Android';
    if (/\biPad\b|\biPhone\b|\biPod\b/i.test(ua)) return /iPad/i.test(ua) ? 'iPadOS' : 'iOS';
    if (/CrOS/i.test(ua)) return 'ChromeOS';
    if (/Windows/i.test(ua)) return 'Windows';
    if (/Mac OS X|Macintosh/i.test(ua)) return 'macOS';
    if (/Linux/i.test(ua)) return 'Linux';
    return 'unknown';
  };

  // iPadOS 13+ は UA が "Macintosh" になるケースへの対策
  const isIpadLike = () =>
    (/\biPad\b/.test(navigator.userAgent)) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const classifyByHeuristic = () => {
    const ua = navigator.userAgent;
    let os = osFromUA(ua);
    if (os === 'macOS' && isIpadLike()) os = 'iPadOS';

    const uaLower = ua.toLowerCase();
    const isAndroid = os === 'Android';
    const isiPhone = /\biphone\b/.test(uaLower);
    const ipad = os === 'iPadOS';

    let isMobile = false;
    let isTablet = false;

    if (ipad) {
      isTablet = true;
    } else if (isiPhone) {
      isMobile = true;
    } else if (isAndroid) {
      // Android は UA に "Mobile" があればスマホ、なければタブレット傾向
      if (/mobile/i.test(ua)) {
        isMobile = true;
      } else if (hasTouch() && (minDim() >= MIN_TABLET_CSS_PX || coarsePointer())) {
        isTablet = true;
      }
    } else {
      // Windows/ChromeOS 等のタブレット（Surface等）をざっくり拾う
      if (hasTouch() && minDim() >= MIN_TABLET_CSS_PX && coarsePointer()) {
        isTablet = true;
      }
    }

    const formFactor = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
    return { os, isMobile, isTablet, isDesktop: !isMobile && !isTablet, formFactor, source: 'heuristic' };
  };

  const classifyWithUACh = async () => {
    try {
      const uaData = navigator.userAgentData;
      if (!uaData) return classifyByHeuristic();

      const hi = await uaData.getHighEntropyValues?.(['platform', 'model', 'platformVersion']) ?? {};
      const platform = hi.platform || uaData.platform || '';
      const model = hi.model || '';
      const mobileCH = !!uaData.mobile;

      // OS 正規化
      const os =
        /Android/i.test(platform) ? 'Android' :
        /iOS|iPadOS/i.test(platform) ? (/\biPad\b/i.test(model) ? 'iPadOS' : 'iOS') :
        /Chrome OS/i.test(platform) ? 'ChromeOS' :
        /Windows/i.test(platform) ? 'Windows' :
        /macOS/i.test(platform) ? (isIpadLike() ? 'iPadOS' : 'macOS') :
        'unknown';

      // UA-CH の mobile は「スマホのみ true」（タブレットは false）
      let isMobile = mobileCH;
      let isTablet = false;

      if (!isMobile) {
        // タブレット推定（タッチ+最小辺>=600 など）
        if (hasTouch() && (minDim() >= MIN_TABLET_CSS_PX || coarsePointer())) {
          // iPad/Android の場合はタブレット扱い
          if (os === 'iPadOS' || os === 'Android' || os === 'Windows' || os === 'ChromeOS') {
            isTablet = true;
          }
        }
      }

      const formFactor = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
      return { os, isMobile, isTablet, isDesktop: !isMobile && !isTablet, formFactor, source: 'ua-ch' };
    } catch {
      return classifyByHeuristic();
    }
  };

  const getInfo = async () => ('userAgentData' in navigator ? classifyWithUACh() : classifyByHeuristic());
  const getInfoSync = () => classifyByHeuristic();

  return { getInfo, getInfoSync };
})();